export default {"src":"/_next/static/media/iconHelpCenter.d778fce4.svg","height":36,"width":45,"blurWidth":0,"blurHeight":0};